import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CJMHttpClientService } from '@cjm/shared/core';
import { VLoketEndpoints } from '@cjm/shared/endpoint';

import { InTheSpotlightResultEntity } from './in-the-spotlight.api.types';

@Injectable()
export class InTheSpotlightApiService {
	constructor(private readonly httpClient: CJMHttpClientService) {
		httpClient.setIncludeLanguage(false);
	}

	/**
	 *  getSpotlightItems
	 *
	 *  The getSpotlightItems method retrieves spotlight items from the server.
	 *
	 * @returns {Observable<InTheSpotlightResultEntity>} An Observable that emits the spotlight items.
	 */
	public getSpotlightItems(): Observable<InTheSpotlightResultEntity> {
		return this.httpClient.get(VLoketEndpoints.InTheSpotlight.InTheSpotlight());
	}
}
